
import React, { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import ErrorDialog from "./leaderboard/ErrorDialog";

interface DataCheckWrapperProps {
  selectedTab: string;
  onTabChange: (value: string) => void;
  children: React.ReactNode;
}

const DataCheckWrapper: React.FC<DataCheckWrapperProps> = ({ 
  selectedTab, 
  onTabChange, 
  children 
}) => {
  const [hasData, setHasData] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showDialog, setShowDialog] = useState(false);

  useEffect(() => {
    const checkUserData = async () => {
      try {
        setIsLoading(true);
        const { data: { user } } = await supabase.auth.getUser();
        
        if (user) {
          const { count, error } = await supabase
            .from('leaderboard')
            .select('*', { count: 'exact', head: true })
            .eq('user_id', user.id);
          
          if (error) {
            console.error('Error checking leaderboard data:', error);
            setHasData(null);
            return;
          }
          
          // If count > 0, user has data
          setHasData(count !== null && count > 0);
        }
      } catch (error) {
        console.error('Error in checkUserData:', error);
        setHasData(null);
      } finally {
        setIsLoading(false);
      }
    };
    
    checkUserData();
  }, [selectedTab]);

  useEffect(() => {
    if (hasData === false && selectedTab !== "leaderboard" && !isLoading) {
      // Show dialog only, toast notification removed
      setShowDialog(true);
      
      // Revert back to leaderboard tab
      onTabChange("leaderboard");
    }
  }, [hasData, selectedTab, isLoading, onTabChange]);

  return (
    <>
      {children}
      
      <ErrorDialog
        isOpen={showDialog}
        onOpenChange={setShowDialog}
        errorMessage="Please import an Excel file in the Leader Board tab before proceeding to other tabs."
        title="No Data Available"
      />
    </>
  );
};

export default DataCheckWrapper;
